export const THEME_COLORS = {
  PRIMARY_LIGHT: '#3D9EFF',
  PRIMARY: '#5C7393',
  PRIMARY_DARK: '#364C63',
  SECONDARY: '#FF811D',
  BACKGROUND_COLOR: '#F0F2F3',
  BACKGROUND_WHITE: '#FFFFFF',
  NOTE_TEXT_GRAY: '#909DA9',
  MAIN_NAV_BUTTON: '#161E29',
  ACTIVE: '#009A5B',
  INACTIVE: '#B1876A',
  BLACK: '#000000',
};
